import state from '../state'

import auth from '@/mixins/auth'
import editState from '@/mixins/edit-state'
import componentState from '@/mixins/component-state'

import imageProxy from '@/libs/image-proxy'
import projectTemplates from '@/mixins/project-templates'

export default {
  mixins: [componentState, auth, editState, projectTemplates],

  props: ['fromTemplate', 'fromPostCreate', 'fromStartButtonTemplate'],

  data: function () {
    return {
      newTitle: '',
      newDescription: '',
      newImage: '',
      isSaved: false,
      isSaving: false,
      togglePrivate: false,
      edit: false,
      chosenTags: [],
      chosenCategories: [],
      showConfirmPublishModal: false,
      showProjectPhoto: false,
      newCaption: ''
    }
  },
  created: function () {
    let currentPage = ''
    if (this.project.sourceProjectID === this.ScienceDayTemplate) {
      currentPage = 'scienceday'
    } else if (this.project.sourceProjectID === this.BIOTemplate) {
      currentPage = 'BIO'
    }
    this.$store.dispatch('getCategories', currentPage)
  },
  mounted: function () {
    if (this.renameProjectRequired) {
      this.edit = true
    }
    this.togglePrivate = this.isPrivate
    this.hasConfirmedPublic = !this.togglePrivate
  },
  methods: {
    viewProfile: function (username) {
      if (username) {
        this.$router.push({ name: 'profile', params: { username } })
      } else {
        this.$router.push({ name: 'profile', params: { username: this.username } })
      }
    },
    uploadImage: function (bucketName, key) {
      if (this.$refs.imageUpload) {
        return this.$refs.imageUpload.upload(bucketName, key)
      }
    },
    saveChanges: function () {
      if (!this.isSaved && this.edit) {
        var data = { id: this.project.id, title: this.newTitle, tag: this.chosenTags, category: this.chosenCategories, image: this.newImage, description: this.newDescription, caption: this.newCaption }
        this._set(this.headerDataKey, data)
        this.edit = false
      }
    },
    toggleProjectPhoto: function () {
      if (this.projectImage) {
        this.showProjectPhoto = !this.showProjectPhoto
      }
    },
    toggleConfirmPublishModal: function () {
      this.showConfirmPublishModal = !this.showConfirmPublishModal
    }
  },

  computed: {
    isStory: function () {
      return this.$route.name === 'viewStory'
    },
    basePath: function () {
      return this.isStory ? '/story' : '/project'
    },
    isPrivate: function () {
      return this.project ? this.project.isPrivate : false
    },
    canEdit: function () {
      return this._get(state.project.permissions.edit, false)
    },
    projectImageSmall: function () {
      return this.project.image ? imageProxy.projectSmall(this.project.image) : false
    },
    projectImage: function () {
      if (!this.project.imageUrl) {
        return imageProxy.project('/static/boardTypes/project-gradient.svg')
      }

      if (this.isStory) {
        return imageProxy.proxy(this.project.imageUrl, { width: 900, height: 500, quality: 80, toPng: true })
      }

      return imageProxy.project(this.project.imageUrl)
    },
    projectImageBackground: function () {
      const style = {}
      if (this.projectImage) {
        const url = this.projectImage
        style.backgroundImage = `url('${url}')`
      }
      return style
    },
    avatar: function () {
      return this.project && this.project.user ? imageProxy.thumbnail(this.project.user.avatar) : ''
    },
    username: function () {
      return this.project.user ? this.project.user.userName : ''
    },
    fullname: function () {
      return this.project.user ? this.project.user.fullName : ''
    },
    isPublic: function () {
      return !this.togglePrivate
    },
    headerDataKey: function () {
      return `object.projectHeader.${this.project.id}`
    },
    project: function () {
      return this._get(state.project.id) ? this.$store.getters.project(this._get(state.project.id)) || {} : {}
    },
    posts: function () {
      return this._get(state.project.id) ? this.$store.getters.projectPosts(this._get(state.project.id), this.isSortedNewestFirst) || [] : []
    },
    seenDescription: function () {
      return this.project && this.project.description && !!this.project.description.length
    },
    htmlDescriptionWordCount: function () {
      return this.newDescription.trim().split(/\s+/).length
    }
  },
  beforeDestroy: function () {
    this.saveChanges()
  }
}
